import DigiLogoSmall from './logos/small.png';

export const LogoIcon = () => {
  return <img src={DigiLogoSmall} width="30" alt="Digitalist Open Cloud" />;
};

export default LogoIcon;
